import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

import { ToasterService } from 'common/src/modules/ui-components/toaster';
import { BaseModalComponent } from 'common/src/modules/rnpl-common/components';
import { ProductModel } from 'common/src/modules/products/models';
import { ProductsService } from 'common/src/modules/products/products.service';
import { CustomSearchFn } from '../../../rnpl-common/helpers';
import { ProductUnitApiService } from 'projects/workspace/src/app/shared/services';
import { ProductUnitModel } from 'projects/workspace/src/app/shared/models';

type SubmitRequestFunction = (product: {productId: number, quantity: number}) => Observable<ProductModel>;

@Component({
  selector: 'rnpl-add-bundle-product-modal',
  templateUrl: './add-bundle-product-modal.component.html',
})
export class AddBundleProductModalComponent extends BaseModalComponent implements OnInit {

  public productsList: ProductModel[] = [];
  public selectedProduct: ProductModel;
  public quantity: number = 1;
  public selectedProductInvalid: boolean = false;
  public customSearchFn = CustomSearchFn;

  readonly showDropdownSpin$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    public toasterService: ToasterService,
    public productsService: ProductsService,
    public productUnitApiService: ProductUnitApiService,
    public dialogRef: MatDialogRef<AddBundleProductModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      submitRequestFn$: SubmitRequestFunction,
    //   productIds: number[]
    }
  ) {
    super(toasterService);

    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });
  }

  ngOnInit() {
    this.showDropdownSpin$.next(true);
    this.getProducts();
  }

  private getProducts(): void {
    this.productsService.getActiveProducts(undefined, false, false, null)
      .pipe(takeUntil(this._destroy))
      .subscribe((products: ProductModel[]) => {
        this.productsList = products
          .map((item: ProductModel) => ({
            ...item,
            searchLabel: `${item.runple_id} ${item.name} ${item.description}`
          }));
        this.showDropdownSpin$.next(false);
      });
  }

  public setUnitTypeModel(): void {
    this.productUnitApiService.getUnits$(this.selectedProduct.type)
      .pipe(takeUntil(this._destroy))
      .subscribe((units: ProductUnitModel[]) => {
        const unit: ProductUnitModel = units.find(u => u.name === this.selectedProduct.unit_type);
        this.selectedProduct = {
          ...this.selectedProduct,
          allowFractionalValues: unit.allowFractionalValues
        };
      });
  }

  public submit(): void {
    if (!this.selectedProduct) {
      this.selectedProductInvalid = true;
      return;
    }

    if (this.data && this.data.submitRequestFn$) {
      // update existing bundled product
      this.data.submitRequestFn$({productId: +this.selectedProduct.id, quantity: this.quantity})
        .subscribe(() => this.dialogRef.close());
    } else {
      // add product on "Create bundle" modal
      this.dialogRef.close(this.selectedProduct);
    }

  }

}
